import { useNavigate } from "react-router-dom";
import trans, { isRTL } from "../../../../../utils";
import Button from "../../../../Helpers/Button/Button";
import { useContext } from "react";
import { popupcontext } from "../../../../../context/Popupscontext";

export default function SetupFooter({
	setPage,
	page,
	handleSubmit,
	loading,
	setDisableNext,
	uniqueId,
	setUniqueId,
	pushImage,
	selectedId,
	select,
	setSelect,
	setSelected,
	setTypeId,
}) {
	const navigate = useNavigate();
	let { konvaMode, setContinueSetup } = useContext(popupcontext);
	return (
		<div
			style={{
				height: "48px",
				backgroundColor: "white",
				borderTop: "1px solid #EBECF0",
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
				padding: "16px",
			}}
		>
			<Button
				type="default"
				htmlType="button"
				text={trans("Close")}
				onClick={() => {
					navigate("/setup/project-setup");
				}}
				disabled={loading}
			/>
			<div>
				<Button
					type={page === 1 ? "primary" : "default"}
					htmlType="submit"
					text={page === 1 ? trans("Save & Continue") : trans("Save")}
					disabled={page !== 1 ? loading || konvaMode : loading}
					style={{ marginRight: isRTL && "8px" }}
				/>

				{page !== 1 && page !== 4 && (
					<Button
						type="primary"
						htmlType="button"
						text={trans("Continue")}
						onClick={async () => {
							// pushImage();
							await setTypeId(uniqueId);
							setSelected({ type: null, index: null, polyid: null });
							setSelect(false);
							setPage(page + 1);
							setUniqueId(null);
						}}
						style={{ marginLeft: !isRTL && "8px" }}
						disabled={
							page !== 1 &&
							(loading ||
								(select === false &&
									(selectedId === null || selectedId === undefined)) ||
								(select && (selectedId === null || selectedId === undefined)))
						}
					/>
				)}

				{page === 4 && (
					<Button
						type="primary"
						htmlType="button"
						text={trans("Finish")}
						onClick={() => {
							// setPage(page + 1);
							navigate("/setup/project-setup");
							setContinueSetup(false);
						}}
						style={{ marginLeft: !isRTL && "8px" }}
					/>
				)}
			</div>
		</div>
	);
}
